<template>
  <div class="container">
    <div v-if="user">
      <button @click="$router.go(-1)" class="btn btn-link"><i class="icon icon-back"></i><span>Back</span></button>

      <div class="divider"></div>

      <div v-if="user">
        <ul class="tab">
          <li class="tab-item">
            <a href="" @click.prevent="tab = 0" :class="{active: tab === 0}">Profile</a>
          </li>
          <li v-if="isClient" class="tab-item">
            <a href="" @click.prevent="tab = 1" :class="{active: tab === 1}">Matters</a>
          </li>
          <li v-if="isClient" class="tab-item">
            <a href="" @click.prevent="tab = 2" :class="{active: tab === 2}">VEVO</a>
          </li>
        </ul>

        <userProfile v-if="tab === 0" :user="user"></userProfile>
        <clientMatters v-if="tab === 1" :user="user"></clientMatters>
        <clientVevo v-if="tab === 2" :user="user"></clientVevo>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import utils from '@/components/utils'
import userProfile from '@/components/users/userProfile'
import clientMatters from '@/components/matters/clientMatters'
import clientVevo from '@/components/users/clientvevo'

export default {
  name: 'user',
  props: ['id'],
  mixins: [utils],
  components: {
    userProfile,
    clientMatters,
    clientVevo
  },
  data () {
    return {
      user: null,
      tab: 0
    }
  },
  created: function () {
    this.getUser()
  },
  computed: {
    isClient () {
      if (!this.user) return false
      return this.user.level > 4
    }
  },
  methods: {
    getUser: function () {
      axios.get('/api/get/users/' + this.id)
      .then(res => {
        if (res.data) {
          this.user = res.data
          let p = this.user.profile
          this.$root.$data.pageTitle = p.firstname + ' ' + p.lastname
        }
      })
      .catch(e => { console.log(e) })
    }
  }
}
</script>
<style scoped>
i.icon.icon-back {
  margin: 0 7px 0 0;
  float: left;
  width: 26px;
  height: 26px;
  background-color: #ce4b81;
  border-radius: 2px;
  color: #fff;
}
.btn.btn-link span {
  float: left;
  padding: 3px 0 0 0;
  color: #ce4b81
}
.btn.btn-link:hover i {
  background-color:  #b9336b;
}
.btn.btn-link:hover span {
  color:  #b9336b
}
</style>



// WEBPACK FOOTER //
// user.vue?d3d8b12c